export const featureSections = ["location", "care", "communication", "safety", "device", "account"];

const choice = (key, labelKey, value, options) => ({ type: "choice", key, labelKey, value, options });
const toggle = (key, labelKey, value = false) => ({ type: "toggle", key, labelKey, value });
const field = (key, labelKey, value = "", inputMode = "text") => ({ type: "field", key, labelKey, value, inputMode });
const action = (key, labelKey) => ({ type: "action", key, labelKey });

export const featureCatalog = [
  {
    id: "locationSources", section: "location", symbol: "◎", status: "demo",
    titleKey: "feature.locationSources", summaryKey: "feature.locationSourcesSummary",
    controls: [toggle("filterLbs", "control.filterLbs"), toggle("filterWifi", "control.filterWifi")],
  },
  {
    id: "uploadInterval", section: "location", symbol: "↻", status: "demo",
    titleKey: "feature.uploadInterval", summaryKey: "feature.uploadIntervalSummary",
    controls: [choice("interval", "control.interval", "10m", ["powerSave", "1m", "10m", "1h", "6h", "12h"])],
  },
  {
    id: "routeHistory", section: "location", symbol: "⌁", status: "ready",
    titleKey: "feature.routeHistory", summaryKey: "feature.routeHistorySummary",
    controls: [choice("period", "control.period", "today", ["today", "yesterday", "custom"]), toggle("showLbs", "control.showLbs", true)],
  },
  {
    id: "gpsFence", section: "location", symbol: "⌖", status: "demo",
    titleKey: "feature.gpsFence", summaryKey: "feature.gpsFenceSummary",
    controls: [toggle("enabled", "control.enabled", true), field("radius", "control.radius", "250", "numeric"), choice("alarm", "control.alarmDirection", "both", ["enter", "leave", "both"])],
  },
  {
    id: "wifiFence", section: "location", symbol: "◉", status: "gated",
    titleKey: "feature.wifiFence", summaryKey: "feature.wifiFenceSummary",
    controls: [toggle("enabled", "control.enabled"), field("name", "control.fenceName", "Home"), field("bssid", "control.bssid", "", "text")],
  },
  {
    id: "heartPressure", section: "care", symbol: "♥", status: "gated",
    titleKey: "feature.heartPressure", summaryKey: "feature.heartPressureSummary",
    controls: [action("measure", "control.measureNow"), field("lowPulse", "control.lowPulse", "45", "numeric"), field("highPulse", "control.highPulse", "120", "numeric")],
  },
  {
    id: "activity", section: "care", symbol: "◌", status: "demo",
    titleKey: "feature.activity", summaryKey: "feature.activitySummary",
    controls: [toggle("enabled", "control.enabled", true), field("stride", "control.stride", "68", "numeric"), field("weight", "control.weight", "72", "numeric")],
  },
  {
    id: "medication", section: "care", symbol: "✚", status: "gated",
    titleKey: "feature.medication", summaryKey: "feature.medicationSummary",
    controls: [toggle("enabled", "control.enabled", true), choice("repeat", "control.repeat", "daily", ["once", "daily", "custom"]), field("time", "control.time", "08:00"), field("message", "control.message", "Morning medicine")],
  },
  {
    id: "temperature", section: "care", symbol: "°", status: "gated",
    titleKey: "feature.temperature", summaryKey: "feature.temperatureSummary",
    controls: [choice("mode", "control.measurementMode", "once", ["once", "cycle", "scheduled"]), field("time", "control.time", "09:00"), action("measure", "control.measureNow")],
  },
  {
    id: "oxygen", section: "care", symbol: "O₂", status: "gated",
    titleKey: "feature.oxygen", summaryKey: "feature.oxygenSummary",
    controls: [action("measure", "control.measureNow")],
  },
  {
    id: "callTracker", section: "communication", symbol: "☎", status: "gated",
    titleKey: "feature.callTracker", summaryKey: "feature.callTrackerSummary",
    controls: [action("call", "control.startCall")],
  },
  {
    id: "voiceTalk", section: "communication", symbol: "◖", status: "gated",
    titleKey: "feature.voiceTalk", summaryKey: "feature.voiceTalkSummary",
    controls: [action("record", "control.holdToTalk")],
  },
  {
    id: "voiceMonitor", section: "communication", symbol: "◉", status: "locked",
    titleKey: "feature.voiceMonitor", summaryKey: "feature.voiceMonitorSummary", controls: [],
  },
  {
    id: "sosNumbers", section: "safety", symbol: "SOS", status: "gated",
    titleKey: "feature.sosNumbers", summaryKey: "feature.sosNumbersSummary",
    controls: [field("sos1", "control.sos1"), field("sos2", "control.sos2"), field("sos3", "control.sos3")],
  },
  {
    id: "phonebook", section: "safety", symbol: "♙", status: "gated",
    titleKey: "feature.phonebook", summaryKey: "feature.phonebookSummary",
    controls: [field("name1", "control.contactName", "Anna"), field("number1", "control.contactNumber"), field("name2", "control.contactName", "Jens"), field("number2", "control.contactNumber")],
  },
  {
    id: "smsAlarm", section: "safety", symbol: "✉", status: "gated",
    titleKey: "feature.smsAlarm", summaryKey: "feature.smsAlarmSummary",
    controls: [toggle("enabled", "control.enabled", true)],
  },
  {
    id: "removalAlarm", section: "safety", symbol: "◇", status: "gated",
    titleKey: "feature.removalAlarm", summaryKey: "feature.removalAlarmSummary",
    controls: [toggle("enabled", "control.enabled"), choice("notify", "control.notificationMethod", "push", ["push", "sms", "call"])],
  },
  {
    id: "safeMode", section: "safety", symbol: "◆", status: "gated",
    titleKey: "feature.safeMode", summaryKey: "feature.safeModeSummary",
    controls: [toggle("enabled", "control.enabled", true)],
  },
  {
    id: "sceneMode", section: "safety", symbol: "◒", status: "gated",
    titleKey: "feature.sceneMode", summaryKey: "feature.sceneModeSummary",
    controls: [choice("mode", "control.scene", "soundVibrate", ["soundVibrate", "sound", "vibrate", "silent"])],
  },
  {
    id: "alarmClock", section: "safety", symbol: "◷", status: "gated",
    titleKey: "feature.alarmClock", summaryKey: "feature.alarmClockSummary",
    controls: [toggle("enabled", "control.enabled", true), choice("repeat", "control.repeat", "daily", ["once", "daily", "custom"]), field("time", "control.time", "07:30")],
  },
  {
    id: "findTracker", section: "safety", symbol: "⌕", status: "gated",
    titleKey: "feature.findTracker", summaryKey: "feature.findTrackerSummary",
    controls: [action("find", "control.ringTracker")],
  },
  {
    id: "answerMode", section: "safety", symbol: "☎", status: "gated",
    titleKey: "feature.answerMode", summaryKey: "feature.answerModeSummary",
    controls: [choice("mode", "control.answerMode", "press", ["press", "handsFree"])],
  },
  {
    id: "speakingClock", section: "safety", symbol: "◷", status: "gated",
    titleKey: "feature.speakingClock", summaryKey: "feature.speakingClockSummary",
    controls: [toggle("enabled", "control.enabled")],
  },
  {
    id: "callerId", section: "safety", symbol: "Aa", status: "gated",
    titleKey: "feature.callerId", summaryKey: "feature.callerIdSummary",
    controls: [toggle("enabled", "control.enabled", true)],
  },
  {
    id: "fallAlarm", section: "safety", symbol: "!", status: "gated",
    titleKey: "feature.fallAlarm", summaryKey: "feature.fallAlarmSummary",
    controls: [toggle("enabled", "control.enabled", true), toggle("call", "control.callOnAlarm", true)],
  },
  {
    id: "fallSensitivity", section: "safety", symbol: "≋", status: "gated",
    titleKey: "feature.fallSensitivity", summaryKey: "feature.fallSensitivitySummary",
    controls: [choice("level", "control.sensitivity", "5", ["1", "3", "5", "7", "9"])],
  },
  {
    id: "powerSchedule", section: "safety", symbol: "◷", status: "locked",
    titleKey: "feature.powerSchedule", summaryKey: "feature.powerScheduleSummary",
    controls: [toggle("powerOn", "control.scheduledOn"), field("onTime", "control.onTime", "07:00"), toggle("powerOff", "control.scheduledOff"), field("offTime", "control.offTime", "22:00")],
  },
  {
    id: "deviceInfo", section: "device", symbol: "▣", status: "demo",
    titleKey: "feature.deviceInfo", summaryKey: "feature.deviceInfoSummary",
    controls: [field("deviceName", "control.deviceName", "Mila tracker"), field("devicePhone", "control.devicePhone"), field("contactName", "control.contactName", "Anna"), field("contactNumber", "control.contactNumber"), toggle("filterLbs", "control.filterLbs"), toggle("filterWifi", "control.filterWifi")],
  },
  {
    id: "languageTimezone", section: "device", symbol: "◎", status: "gated",
    titleKey: "feature.languageTimezone", summaryKey: "feature.languageTimezoneSummary",
    controls: [choice("language", "control.trackerLanguage", "english", ["english", "danish", "swedish", "norwegian"]), choice("timezone", "control.timezone", "+1", ["0", "+1", "+2"])],
  },
  {
    id: "notifications", section: "device", symbol: "●", status: "gated",
    titleKey: "feature.notifications", summaryKey: "feature.notificationsSummary",
    controls: [toggle("enabled", "control.enabled", true), toggle("sound", "control.sound", true), toggle("vibration", "control.vibration", true)],
  },
  {
    id: "restart", section: "device", symbol: "↻", status: "locked",
    titleKey: "feature.restart", summaryKey: "feature.restartSummary", controls: [],
  },
  {
    id: "powerOff", section: "device", symbol: "○", status: "locked",
    titleKey: "feature.powerOff", summaryKey: "feature.powerOffSummary", controls: [],
  },
  {
    id: "factoryReset", section: "device", symbol: "△", status: "locked",
    titleKey: "feature.factoryReset", summaryKey: "feature.factoryResetSummary", controls: [],
  },
  {
    id: "faq", section: "device", symbol: "?", status: "ready",
    titleKey: "feature.faq", summaryKey: "feature.faqSummary", controls: [],
  },
  {
    id: "userLogin", section: "account", symbol: "♙", status: "demo",
    titleKey: "feature.userLogin", summaryKey: "feature.userLoginSummary",
    controls: [field("email", "auth.email", "demo@qsmart.invalid", "email"), field("password", "auth.password", "", "password"), toggle("remember", "control.rememberLogin", true), action("signIn", "auth.submit")],
  },
  {
    id: "deviceBinding", section: "account", symbol: "▦", status: "gated",
    titleKey: "feature.deviceBinding", summaryKey: "feature.deviceBindingSummary",
    controls: [field("deviceId", "device.identifier"), field("password", "auth.password", "", "password"), action("scanQr", "control.scanQr")],
  },
  {
    id: "password", section: "account", symbol: "◇", status: "gated",
    titleKey: "feature.password", summaryKey: "feature.passwordSummary",
    controls: [field("current", "control.currentPassword", "", "password"), field("next", "control.newPassword", "", "password"), field("repeat", "control.repeatPassword", "", "password")],
  },
  {
    id: "logout", section: "account", symbol: "→", status: "demo",
    titleKey: "feature.logout", summaryKey: "feature.logoutSummary",
    controls: [action("logout", "feature.logout")],
  },
];

export function featuresForSection(section) {
  return featureCatalog.filter((feature) => feature.section === section);
}

export function createInitialFeatureValues() {
  return Object.fromEntries(featureCatalog.map((feature) => [
    feature.id,
    Object.fromEntries(feature.controls.filter((control) => control.type !== "action").map((control) => [control.key, control.value])),
  ]));
}
